module.exports = __webpack_public_path__ + "img/balma.c4a9f9dd.jpg";